import { render, staticRenderFns } from "./Pedidos.vue?vue&type=template&id=7f249a00&scoped=true"
import script from "./Pedidos.vue?vue&type=script&lang=js"
export * from "./Pedidos.vue?vue&type=script&lang=js"
import style0 from "./Pedidos.vue?vue&type=style&index=0&id=7f249a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f249a00",
  null
  
)

export default component.exports